import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import { Icon } from "@iconify/react";

const EmailForm = () => {
  const formRef = useRef();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Please Enter Email ID*",
      });
      return;
    }

    setLoading(true);

    emailjs
      .send(
        "service_xfr4oxd",
        "template_jwwhupd",
        { email: email },
        "ywp8aCLBaYoSSCeRG"
      )
      .then(() => {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Thank you !",
          text: "We'll get back to you soon !",
        });
        setEmail("");
        formRef.current.reset();
      })
      .catch((error) => {
        console.log(error); // 🔥 important for debugging
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Email failed to send",
        });
      });
  };

  return (
    <form
      ref={formRef}
      onSubmit={handleSubmit}
      className="newsLetterInput d-flex align-items-center justify-content-center wow animate__animated animate__fadeIn animation_delay_300ms"
    >
      <input
        type="email"
        placeholder="example@reversethought.com"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <button type="submit" disabled={loading}>
        {loading ? (
          <span className="spinner-border spinner-border-sm text-light"></span>
        ) : (
          <Icon icon="maki:arrow" color="white" />
        )}
      </button>
    </form>
  );
};

export default EmailForm;